import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@antimatterhq/ui/lib/utils';

const textareaVariants = cva(
  [
    'flex min-h-[80px] w-full rounded-md border px-3 py-2 text-sm',
    'bg-white dark:bg-transparent',
    'placeholder:text-grey-400 dark:placeholder:text-grey-500',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
    'disabled:cursor-not-allowed disabled:opacity-50',
  ],
  {
    variants: {
      variant: {
        default: [
          'border-grey-300 dark:border-grey-650',
          'text-grey-800 dark:text-grey-100',
          'focus-visible:ring-blue-600 dark:focus-visible:ring-blue-500',
        ],
        success: [
          'border-green-600 dark:border-green-500',
          'text-green-600 dark:text-green-500',
          'focus-visible:ring-green-600 dark:focus-visible:ring-green-500',
        ],
        warning: [
          'border-yellow-600 dark:border-yellow-500',
          'text-yellow-600 dark:text-yellow-500',
          'focus-visible:ring-yellow-600 dark:focus-visible:ring-yellow-500',
        ],
        error: [
          'border-red-600 dark:border-red-500',
          'text-red-600 dark:text-red-500',
          'focus-visible:ring-red-600 dark:focus-visible:ring-red-500',
        ],
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    VariantProps<typeof textareaVariants> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <textarea
        className={cn(textareaVariants({ variant }), className)}
        ref={ref}
        {...props}
      />
    );
  },
);

Textarea.displayName = 'Textarea';

export { Textarea };
